import {createSlice} from "@reduxjs/toolkit";

const lessonsProgramSlice = createSlice({
    name: "lessonsProgram",
    initialState: [    ],
    reducers: {
        setAllLessons: (state, action)=>{
            return [...action.payload]
        }
    }
})

export const {setAllLessons} = lessonsProgramSlice.actions;
export default lessonsProgramSlice.reducer;
